<template>
  <v-app>
    <v-toolbar
      fixed app
      :height="toolbar.height"
      :clipped-left="clipped"
      :flat="toolbar.flat"
      class="toolbar"
    >
      <div class="logo">
        <img class="ml-3" src="../assets/img/logo.png" alt="Imgate">
      </div>
      <div class="toolbar-menu">
        <router-link :to="{ name: 'bookings' }">
          <button
            class="menu-btn"
            type="button"
          >
            <span class="icon"><i class="far fa-calendar-alt"></i></span>
            <span class="name">BOOKING</span>
          </button>
        </router-link>
        <router-link :to="{ name: 'hotels' }">
          <button
            class="menu-btn"
            type="button"
          >
            <span class="icon"><i class="fas fa-h-square"></i></span>
            <span class="name">HOTEL</span>
          </button>
        </router-link>
        <router-link :to="{ name: 'doorlocks' }">
          <button
            class="menu-btn"
            type="button"
          >
            <span class="icon"><i class="fas fa-unlock-alt"></i></span>
            <span class="name">DOORLOCK</span>
          </button>
          <span class="toolbar-menu-border"></span>
        </router-link>
        <router-link :to="{ name: 'users' }" v-if="userMenuVisible">
          <button
            class="menu-btn"
            type="button"
          >
            <span class="icon"><i class="fas fa-briefcase"></i></span>
            <span class="name">USER</span>
          </button>
        </router-link>
        <router-link :to="{ name: 'staffs' }">
          <button
            class="menu-btn"
            type="button"
          >
            <span class="icon"><i class="fas fa-users"></i></span>
            <span class="name">STAFF</span>
          </button>
        </router-link>
        <router-link :to="{ name: 'admins' }">
          <button
            class="menu-btn"
            type="button"
          >
            <span class="icon"><i class="fas fa-sitemap"></i></span>
            <span class="name">ADMIN</span>
          </button>
        </router-link>
        <router-link :to="{ name: 'domains' }" v-if="domainMenuVisible">
          <button
            class="menu-btn"
            type="button"
          >
            <span class="icon"><i class="fas fa-flag"></i></span>
            <span class="name">DOMAIN</span>
          </button>
          <span class="toolbar-menu-border"></span>
        </router-link>
        <router-link :to="{ name: 'auditLogs' }">
          <button
            class="menu-btn"
            type="button"
          >
            <span class="icon"><i class="fas fa-desktop"></i></span>
            <span class="name">AUDIT LOG</span>
          </button>
          <span class="toolbar-menu-border"></span>
        </router-link>
      </div>
      <v-spacer></v-spacer>
      <span class="user-name">{{ user.name }}</span>
      <span class="user-email ml-2">({{ user.email }})</span>
      <div class="toolbar-menu">
        <button class="menu-btn" type="button" @click="signout">
          <span class="icon"><i class="fas fa-lock fa-fw"></i></span>
          <span class="name">LOGOUT</span>
        </button>
      </div>
    </v-toolbar>
    <v-content id="test">
      <v-slide-x-transition mode="out-in">
        <router-view :storeFilter="storeFilter" :storePage="storePage"></router-view>
      </v-slide-x-transition>
    </v-content>
    <v-footer class="ch-footer" app fixed>
      <span>Copyright ⓒ ImGATE ALL RIGHTS RESERVED.</span>
      <v-spacer></v-spacer>
      <ul>
        <li>
          <a href="#">
            <i class="far fa-copyright"></i>
            ImGATE
          </a>
        </li>
      </ul>
    </v-footer>
  </v-app>
</template>

<script>
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import boolResetStore from '@/components/customized-components/boolResetStore';
  import api from '../api';

  export default {
    data() {
      return {
        storeFilter: null,
        storePage: null,
        timer: null,
        // NOTE: Navigation option
        clipped: true,
        drawer: true,
        user: {
          name: null,
          email: null,
        },
        // miniVariant: false,
        // NOTE: Toolbars option
        title: 'ImGATE Hospitality',
        adminId: 'kisstest',
        // NOTE: Window size
        windowSize: {
          x: 0,
          y: 0,
        },
        // NOTE: toolbar setting
        toolbar: {
          height: 70,
          flat: true,
        },
        // NOTE: mouse hover
        hoverMenu: false,
        domainMenuVisible: false,
        userMenuVisible: false,
        bookingMenuVisible: false,
      };
    },
    methods: {
      /**
       * @description 목록 페이지의 필터 값 저장
       */
      setFilter(filter) {
        this.storeFilter = Object.assign({}, filter);
      },
      /**
       * @description 필터 초기화, 다른 메뉴로 이동시
       */
      resetStore() {
        this.storeFilter = {};
        this.storePage = {};
      },
      setPage(page) {
        // console.log(`setFilter, page: ${JSON.stringify(page)}`);
        this.storePage = Object.assign({}, page);
      },
      //------------------------------------------------------------------------
      signout() {
        api.signout()
        .then((result) => {
          if (result.status === 200) {
            localStorage.clear();
            this.$router.push({ name: 'signIn' });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
    },
    watch: {
      // NOTE: 라우트가 변경될 때, 같은 메뉴의 [목록, 상세]가 맞는지 파악
      $route(to, from) {
        if (boolResetStore(to, from)) this.resetStore();
      },
    },
    mounted() {
      console.log('admin mount');
      this.user.name = localStorage.getItem('name');
      this.user.email = localStorage.getItem('email');
      window.addEventListener('storage', () => {
        this.signout();
      });
      // NOTE: 필터 저장
      storeFilterEventBus.$on('setFilter', (filter) => {
        this.setFilter(filter);
      });
      storeFilterEventBus.$on('setPage', (page) => {
        this.setPage(page);
      });
    },
    created() {
      if (localStorage.getItem('domain_type') === 'root') {
        this.domainMenuVisible = true;
        this.userMenuVisible = true;
      }
    },
  };
</script>

<style lang="scss" scoped>
.logo {
  min-width: 220px;
  margin-top: 10px;

  > img {
    max-width: 100%;
  }
}
.toolbar {
  background-color: #333;

  .menu-btn {
    height: 50px;
    width: 85px;
    text-align: center;
    color: #666;
    padding: 5px 0;
    float: left;
    line-height: 20px;
    // margin-right: 10px;
    font-size: 10px;

    &:hover{
      color: #FF6C00;
      float: left;

      .icon {
        color: #FF6C00;
      }
    }
    .icon {
      display: block;
      font-size: 26px;
      color: #666
    }
    .name {
      position: relative;
      font-weight: bold;
    }
  }
  .router-link-active .menu-btn,
  .router-link-exact-active .menu-btn,
  .router-link-active .menu-btn .icon,
  .router-link-exact-active .menu-btn .icon {
    color: #FF6C00;
  }
  .user-name {
    color: white;
  }
  .user-email {
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue